import "./Steps.css";

import React, { Component } from "react";

class StepThankYou extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stepNumber: 7,
      fields: {
        relationship: "",
        education: "",
        occupation: "",
        lifestyleExpectations: ""
      }
    };
  }

  handleFieldChange(e, name) {
    let fields = this.state.fields;
    fields[name] = e.target.value;

    this.setState({ fields });
  }

  render() {
    return (
      <div
        className={`Step Step-container ${this.props.active ? "active" : ""}`}
      >
        <div className="Step-title">Finished!</div>
        <div className="text-content">
          <div className="title">Thank you for creating your profile!</div>
          <p>Your account is activre. Login to enjoy UpperClassDates.</p>
          <p>The UCD-Team!</p>
        </div>
      </div>
    );
  }
}
export default StepThankYou;



// WEBPACK FOOTER //
// ./src/components/StepThankYou.js